import * as process from 'process';

import { API_URLS } from 'utils/apiUrlBuilder';

export const apiAdvisorsNext = process.env.REACT_APP_URL_ADVISOR_PLATFORM;
export const apiMarketNext = API_URLS.MARKET_PLATFORM;
export const apiDashboardPlatformNext = API_URLS.DASHBOARDS;
export const apiEducationNext = process.env.REACT_APP_BASE_URL;
